export default "__VITE_ASSET__dPqXzNDq__"